// extracted by mini-css-extract-plugin
export default {"button":"ButtonItem__button___Dpcn0","text":"ButtonItem__text___kAXGS"};